import { useCustomSWR } from 'utils/hooks/fetchers'
import { stringify } from 'qs'

export const useGuessLikesByKeyword = (keywordIds = []) => {
  const genUrl = () =>
    keywordIds?.length
      ? `/articles/guessLike?${stringify(
          { keywordIds },
          { arrayFormat: 'repeat' }
        )}`
      : null
  return useCustomSWR(genUrl)
}
